const controlAddToCalendar = (button) => {
    button.addEventListener("click", (e) => {
        const buttonParent = button.closest(".atc__button--container");
        const buttonOptions = buttonParent.querySelector(".atc__button--options");

        if (buttonOptions.classList.contains("active")) {
            buttonOptions.classList.remove("active");
        } else {
            buttonOptions.classList.add("active");
        }
    })
}

export { controlAddToCalendar };